import { Booking, Calendar } from './booking-types';
import { createCalender } from './create-calendar';
import { splitMonthIntoWeeks } from './split-month-into-weeks';
import { splitYearIntoMonths } from './split-year-into-months';

const createCalendar = (year: number, bookings: Booking[], clipMonths: number): Calendar => {
  const yearCells = createCalender(year, bookings);
  const yearMonths = splitYearIntoMonths(year, yearCells);
  const yearMonthsWeeks = yearMonths.map((month, index) => splitMonthIntoWeeks(year, index, month.name, month.days));
  //remove the prefixed clipMonths
  yearMonthsWeeks.splice(0, clipMonths).splice(10, 1);
  //remove december
  yearMonthsWeeks.splice(yearMonthsWeeks.length - 1, 1);
  return { year, months: yearMonthsWeeks };
};

export const createCalenders = (bookings: Booking[]): Calendar[] => {
  const calendars = [];
  const today = new Date();
  const thisYear = today.getFullYear();
  const currentMonth = today.getMonth();

  if (currentMonth < 11) {
    const clipMonths = currentMonth > 2 ? currentMonth : 3;

    calendars.push(createCalendar(thisYear, bookings, clipMonths));
    calendars.push(createCalendar(thisYear + 1, bookings, 3));
  } else {
    calendars.push(createCalendar(thisYear + 1, bookings, 3));
    calendars.push(createCalendar(thisYear + 2, bookings, 3));
  }

  return calendars;
};
